import { getCookie as u, setCookie as c } from "../../../helpers/cookies.js";
import { sendErrorOnboardingEvent as r } from "./onboardingTracking.js";
const s = "header-pro-onboarding",
  d = 2,
  g = 864e5,
  b = 3456e4,
  a = () => {
    const o = u(s, r);
    if (o === null) return null;
    try {
      return JSON.parse(o);
    } catch (n) {
      return r("Error while parsing cookie - ".concat(n.message)), null;
    }
  },
  t = (o, n) => {
    const e = {
      last_date: new Date().toISOString(),
      count: o,
      disable: n
    };
    c(s, JSON.stringify(e), void 0, void 0, b, r);
  },
  i = o => o != null ? o : a(),
  O = o => {
    const n = i(o);
    if (n === null) {
      t(1, !1);
      return;
    }
    t(n.count + 1, n.disable);
  },
  f = o => {
    const n = i(o);
    if (n === null) {
      t(1, !0);
      return;
    }
    t(n.count, !0);
  },
  p = o => {
    const n = i(o);
    if (n === null) return !0;
    const e = Date.parse(n.last_date),
      l = Date.now() - e > g;
    return !n.disable && n.count < d && l;
  };
export { f as disableOnboardingCookie, a as getOnboardingCookie, O as incrementOnboardingCount, p as shouldShowOnboarding };